class APIS {
    apis() {
        return {
            listing: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/fetch/list/conversation_templates'
            },
            create_template: {
                headers: {
                    'xt-user-token': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiIxIiwiYWN0b3IiOiIxIiwidGltZSI6MTU4MTc4MDQ3NjU1MSwiaWF0IjoxNTgxNzgwNDc2fQ.wyHnDSwtkPecdSVO_fdMw5F63VCcQ4A7ULoXWJlK_V0"
                },
                method: 'post',
                path: '/backend/conversation/templates/create'
            },
            update_template: {
                headers: {
                    'xt-user-token': null
                },
                method: 'put',
                path: '/backend/conversation/templates/update/id'
            },
            template_limits: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/request/limits'
            },
            add_templateLimits: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/request/limit/add'
            },
            update_templateLimits: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/request/limit/update'
            },
            delete_templateLimits: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/request/limit/delete'
            },
            create_template_msg: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/create/template/message'
            },
            sub_account_report: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/agent/template/information'
            },
            template_usage_stats: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/template/usage/stats'
            },
            template_monitoring: {
                headers: {
                    'xt-key': '4983eace-bb22-4db7-a391-4df96725b58b',
                },
                method: 'post',
                path: '/template/monitoring'
            },
            template_consumption_email: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/template/consumption/email'
            },
            template_sub_account_detail: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/template/sub-account/detail'
            },
            category_wise_counts: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/template/category-wise/counts'
            },
        }
    }
}

export default new APIS;